import React from "react";
import {
  Box,
  Card,
  CardContent,
  Grid,
  Link,
  Typography,
  Stack,
  useTheme,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { useSessionQuery } from "../../../../auth";
import { ROUTES } from "../../../../../shared/utils";

export const ManagementDashboard: React.FC = () => {
  const theme = useTheme();
  const { data: session } = useSessionQuery();

  const stats = [
    {
      title: "Total Users",
      value: "0",
      icon: <DashboardIcon />,
    },
    {
      title: "Active Users",
      value: "0",
      icon: <DashboardIcon />,
    },
    {
      title: "Pending Requests",
      value: "0",
      icon: <DashboardIcon />,
    },
    {
      title: "System Health",
      value: "100%",
      icon: <DashboardIcon />,
    },
  ];

  return (
    <Box>
      <Stack spacing={3}>
        <Box>
          <Typography variant="h4" component="h1" fontWeight={600} gutterBottom>
            Management Dashboard
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
          >
            <Typography variant="body1" color="text.secondary">
              Welcome back, {session?.user?.firstName} {session?.user?.lastName}
            </Typography>
            <Link component={RouterLink} to={ROUTES.FAQ} underline="hover">
              FAQ
            </Link>
          </Stack>
        </Box>

        <Grid container spacing={3}>
          {stats.map((stat, index) => (
            <Grid size={{ xs: 12, sm: 6, md: 3 }} key={index}>
              <Card
                variant="outlined"
                sx={{
                  height: "100%",
                  borderColor: "divider",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    boxShadow: theme.shadows[4],
                    transform: "translateY(-2px)",
                  },
                }}
              >
                <CardContent>
                  <Stack spacing={2}>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                      }}
                    >
                      <Box
                        sx={{
                          p: 1.5,
                          borderRadius: 2,
                          bgcolor: "primary.main",
                          color: "primary.contrastText",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        {stat.icon}
                      </Box>
                    </Box>
                    <Box>
                      <Typography
                        variant="h4"
                        component="div"
                        fontWeight={600}
                        gutterBottom
                      >
                        {stat.value}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {stat.title}
                      </Typography>
                    </Box>
                  </Stack>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>

        <Card variant="outlined" sx={{ borderColor: "divider" }}>
          <CardContent>
            <Typography variant="h6" component="h2" fontWeight={600} gutterBottom>
              Recent Activity
            </Typography>
            <Typography variant="body2" color="text.secondary">
              No recent activity to display.
            </Typography>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
};
